import React from "react";
import { ConfirmModal } from "../ConfirmModal";
import { DisconnectModalProps } from "./DisconnectModal.types";

const getModalContent = (
  action: "disconnect" | "reconnect" = "disconnect",
) => {
  if (action === "reconnect") {
    return {
      title: "Reconnect integration?",
      description: "This will resume data syncing from this source.",
      infoText: "Paused schedule refreshes will resume.",
      confirmLabel: "Reconnect",
    };
  }
  return {
    title: "Disconnect integration?",
    description:
      "This will stop data syncing from this source. Existing data will remain available, but won't receive updates.",
    infoText: "Schedule refreshes will pause.",
    confirmLabel: "Disconnect",
  };
};

export const DisconnectModal: React.FC<DisconnectModalProps> = ({
  open,
  isLoading = false,
  action = "disconnect",
  onConfirm,
  onCancel,
}) => {
  const content = getModalContent(action);

  return (
    <ConfirmModal
      open={open}
      isLoading={isLoading}
      title={content.title}
      description={content.description}
      infoText={content.infoText}
      infoVariant="warning"
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLabel={content.confirmLabel}
      cancelLabel="Cancel"
      confirmVariant="primary"
    />
  );
};
